import { useTranslation } from "react-i18next";

import ServiceCard from "../../components/ServiceCard/ServiceCard";
import "./Payments.css";

const Payments = () => {
	const { t } = useTranslation();
	const items = t("payments.items", { returnObjects: true });

	return (
		<div className="payments-bg">
			<h1 className="payments-title">{t("payments.title")}</h1>
			<h2 className="payments-subtitle">{t("payments.subtitle")}</h2>

			<div className="payments-content">
				{items.map((item, index) => (
					<ServiceCard
						data={{
							id: index,
							icon: item["icon"],
							alt: item["alt"],
							name: item["name"],
							description: item["text"],
						}}
					/>
				))}
			</div>
		</div>
	);
};

export default Payments;
